import Agriculture from '@/models/Agriculture'
import User, { hasRole, Role } from '@/models/User'

export default class AgriculturePolicy {
	viewAny(_user: User): boolean {
		return true
	}

	view(user: User, agriculture: Agriculture) {
		switch (user.role) {
			case Role.USER:
				return user.company?.id === agriculture.entry.catalog.company.id
			case Role.AUDITOR:
				return agriculture.entry.catalog.company.auditors?.some(auditor => auditor.id === user.auditor?.id)
			default:
				return false
		}
	}

	create(user: User) {
		return hasRole(user, Role.USER)
	}

	update(user: User, agriculture: Agriculture) {
		return hasRole(user, Role.USER) && user.company?.id === agriculture.entry.catalog.company.id
	}

	restore(user: User, agriculture: Agriculture) {
		return hasRole(user, Role.USER) && user.company?.id === agriculture.entry.catalog.company.id
	}

	delete(user: User, agriculture: Agriculture) {
		return hasRole(user, Role.USER) && user.company?.id === agriculture.entry.catalog.company.id
	}

	forceDelete(_user: User, _agriculture: Agriculture) {
		return false
	}
}
